import { Component, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModalConfig, NgbModal, NgbOffcanvas, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AttendanceService } from '../../../../../../core/services/attendance.service';
import { FileService } from '../../../../../../core/services/file.service';
import { AppErrorShow } from '../../../../../../core/utils/app-error-show';
import { AppSweetAlert } from '../../../../../../core/utils/app-sweet-alert';
import { LocalStorageService } from '../../../../../../core/utils/local-stoarge-service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule, NgLabelTemplateDirective, NgOptionTemplateDirective, NgSelectComponent } from '@ng-select/ng-select';
import { NgxPaginationModule } from 'ngx-pagination';
import { SampleSearchPipe } from '../../../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../../../components/loading/loading.component';
import { HeaderComponent } from '../../../../layout/includes/header/header.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';

@Component({
    selector: 'app-attendance-details',
    templateUrl: './attendance-details.component.html',
    imports: [CommonModule, FormsModule, NgbModule, LoadingComponent, SampleSearchPipe, HeaderComponent, NgSelectModule,
        NgxPaginationModule,
        NgLabelTemplateDirective,
        NgOptionTemplateDirective,
        NgSelectComponent,
        NgxExtendedPdfViewerModule
    ],
    styleUrls: ['./attendance-details.component.css']
})
export class AttendanceDetailsComponent {
  buttonsPermission :any|undefined;
  search_text=""
   structures:any[] =[]
   cycles:any[] =[]
   data:any
   selected_data:any;
   modalOption:any; 
   isDtInitialized:boolean = false
   is_active=null
   loading=false
   tag="sauvegardes"
   pg={
     pageSize:10,
     p:0,
     total:0
   }
   role:any
   user:any
   code:any
 
   pdfViewLoader=false
  pdfSrc = "https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf";
  @ViewChild('contentPDF') contentPDF:TemplateRef<any> | undefined

  
   constructor(
     private attendanceService:AttendanceService,
     private activatedRoute:ActivatedRoute,
     private offcanvasService: NgbOffcanvas,
     private fileService:FileService,
     private router:Router,
     private toastrService:ToastrService,
       config: NgbModalConfig,
       private lsService:LocalStorageService,
     private modalService: NgbModal) {
      config.backdrop = 'static';
      config.keyboard = false;
      }
 
 
   ngOnInit(): void {

    this.code=this.activatedRoute.snapshot.paramMap.get('code')
    if (this.code!=undefined) {
      this.init()
    }else{
      this.router.navigate(['/admin/bvs-attendances-book'])
    }
     
      this.getActions()
   }
 
   init(){

     this.getOne()
   
   }
 
 
 
  
 
   getOne(){
     this.attendanceService.get(this.code).subscribe((res:any)=>{
       this.data=res.data
     },
     (err:any)=>{
      AppErrorShow.showError("Gestion des présences",err)

     })
   }
 
 
   store(value:any){
     this.loading=true
     
     this.attendanceService.store(value).subscribe((res:any)=>{
       this.loading=false
 
         this.toastrService.success(res.message)
         this.getOne()
 
     },
     (err:any)=>{
       this.loading=false
 
       console.log(err)
         AppErrorShow.showError("Gestion des présences",err)

     })
   }

   getFile2(path:any,css='details-panel'){
    this.pdfViewLoader=true
    this.fileService.get2({
      path:path
    }).subscribe((res:any)=>{
      this.pdfViewLoader=false
      this.pdfSrc=res[0]
      this.offcanvasService.open(this.contentPDF,{  panelClass: css, position: 'end'  });

    },
    (err:any)=>{
    AppErrorShow.showError("Gestion des présences",err)
    })
  }
   update(value:any){
     this.loading=true
 
     this.attendanceService.update(this.selected_data.id,value).subscribe((res:any)=>{
       this.loading=false
 
         this.toastrService.success(res.message)
         this.getOne()
     },
     (err:any)=>{
       this.loading=false
         AppErrorShow.showError("Gestion des présences",err)

     })
   }
   delete(){
     if(!this.verifyIfElementChecked()) return ;
     let confirmed=AppSweetAlert.confirmBox('info','Suppression','Voulez vous vraiment retirer cet élément?',);
     confirmed.then((result:any)=>{
        if (result.isConfirmed) {
     this.attendanceService.delete(this.selected_data.id).subscribe((res:any)=>{
         this.toastrService.success(res.message)
         this.getOne()
     },
     (err:any)=>{
         AppErrorShow.showError("Gestion des présences",err)

     })
   }
 })
   }
   checked(el?:any){
     this.selected_data=el;
     this.is_active=el.is_active
   }
   verifyIfElementChecked(){
     console.log(this.selected_data)
     if (this.selected_data==null) {
       this.toastrService.warning("Aucun élément selectionné");
       return false;
     }
     return true;
   }
 
 
 
   dismiss(){
     this.modalService.dismissAll()
   }
 
   add(content:any){
     this.modalService.open(content,{size:'lg'});
   }
 
 
   show(content:any){
     if(!this.verifyIfElementChecked()) return ;
     this.modalOption={centered:false,size:"lg"}
     this.modalService.open(content,{size:'lg'});
   }
 
   edit(content:any){
     if(!this.verifyIfElementChecked()) return ;
     this.modalService.open(content,{size:'lg'});
 
   }
 
   setStatus(value:any){
 
     this.toastrService.warning("Opération en cours")
   
         this.attendanceService.setState(this.selected_data.id,value).subscribe((res:any)=>{
           this.toastrService.success(res.message)
           this.getOne()
       },
       (err:any)=>{
           AppErrorShow.showError("Gestion des présences",err)

       })
   }
 
   getPage(event:any){
     this.pg.p=event
   }
 
   getActions(){
     // this.buttonsPermission = {
     //   show:AppActionCheck.check(this.tag,'Consultation'),
     //   add:AppActionCheck.check(this.tag,'ajout'),
     //   edit:AppActionCheck.check(this.tag,'edition'),
     //   delete:AppActionCheck.check(this.tag,'suppression'),
     //   status:AppActionCheck.check(this.tag,'statut')
     // };
     this.buttonsPermission={
       show:false,
       add:true,
       edit:true,
       delete:true,
       status:true,
     }
   }
}
